<template>
<div class="chapter">
<div class="inner_page">
<a id="p2"></a>
<p class="sink"> </p>
<blockquote class="breakafter">
<p class="center "><em>For Owen</em></p>
</blockquote>
<blockquote class="sink">
<p class="left "><b>welsh,</b> <em>v.</em> Also <b>welch</b> [Of obscure origin]</p>
</blockquote>
<blockquote class="indent3">
<p class="hang "><b>1. </b><em>trans.</em> To swindle (a person) out of money laid as a bet.</p>
<p class="hang "><b>2. </b><em>intr.</em> Const. <em>on.</em> To fail to carry out one’s promise to (a person); to fail to keep (an obligation).</p>
</blockquote>
<div class="timebreak "> </div>
<blockquote class="indent3">
<p class="right "><em>—Oxford English Dictionary,</em> 1928</p>
</blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front02.vue?6f437c7c